import * as React from "react";
const SvgSecondaryDisconnected = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-cfa2f77c-e7e7-4341-be6e-9b4172510f55", "data-name": "Warstwa 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m7.75,9.77v12.23c0,.97.78,1.75,1.75,1.75h10c.97,0,1.75-.78,1.75-1.75V6c0-.97-.78-1.75-1.75-1.75h-6.61c-.5,0-.97.21-1.3.58l-3.39,3.77c-.29.32-.45.74-.45,1.17Z", style: {
  fill: "#de3c46",
  stroke: "#2f3232",
  strokeWidth: ".5px"
} }), /* @__PURE__ */ React.createElement("path", { d: "m2.75,5.77v12.23c0,.97.78,1.75,1.75,1.75h10c.97,0,1.75-.78,1.75-1.75V2c0-.97-.78-1.75-1.75-1.75h-6.61c-.5,0-.97.21-1.3.58l-3.39,3.77c-.29.32-.45.74-.45,1.17Z", style: {
  fill: "#fff",
  stroke: "#2f3232",
  strokeWidth: ".5px"
} }));
export default SvgSecondaryDisconnected;
